(function () {
  if (typeof window === 'undefined' || typeof window.routes === 'undefined' || !window.routes.cart_update_url) {
    return;
  }

  const GIFT_PROPERTY = '_free_gift_for';
  const DESIRED_QTY = 1;

  function isGiftLine(item) {
    const props = item && item.properties;
    if (!props) return false;
    return Object.prototype.hasOwnProperty.call(props, GIFT_PROPERTY) && !!props[GIFT_PROPERTY];
  }

  function calculateGiftUpdates(cart) {
    const items = cart && cart.items ? cart.items : [];

    const giftLines = items.filter((item) => isGiftLine(item) && item.key);
    if (giftLines.length === 0) return null;

    // If the cart contains nothing but free gift(s), remove them.
    const onlyGifts = giftLines.length === items.length;
    const targetQty = onlyGifts ? 0 : DESIRED_QTY;

    const updates = {};
    giftLines.forEach((item) => {
      if ((item.quantity || 0) !== targetQty) {
        updates[item.key] = targetQty;
      }
    });

    return Object.keys(updates).length ? updates : null;
  }

  let isProcessing = false;

  function applyGiftUpdates(cart) {
    const updates = calculateGiftUpdates(cart);
    if (!updates || isProcessing) return Promise.resolve(null);

    isProcessing = true;

    const body = JSON.stringify({ updates });

    return fetch(`${routes.cart_update_url}`, { ...fetchConfig('json'), ...{ body } })
      .then((response) => response.json())
      .then((updatedCart) => {
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'gift-quantity-sync', cartData: updatedCart });
        return updatedCart;
      })
      .catch((error) => {
        console.error('Error syncing free gift quantity', error);
        return null;
      })
      .finally(() => {
        isProcessing = false;
      });
  }

  fetch('/cart.js')
    .then((response) => response.json())
    .then((cart) => applyGiftUpdates(cart))
    .catch((error) => {
      console.error('Error fetching cart on initial load for gift quantity sync', error);
    });

  subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
    if (!event || !event.cartData) return;
    applyGiftUpdates(event.cartData);
  });
})();
